// Submit Collection Constants
export const SUBMIT_COLLECTION_REQUEST = 'SUBMIT_COLLECTION_REQUEST'
export const SUBMIT_COLLECTION_SUCCESS = 'SUBMIT_COLLECTION_SUCCESS'
export const SUBMIT_COLLECTION_FAIL = 'SUBMIT_COLLECTION_FAIL'
export const SUBMIT_COLLECTION_RESET = 'SUBMIT_COLLECTION_RESET'

// Get My Collections Constants
export const GET_MY_COLLECTIONS_REQUEST = 'GET_MY_COLLECTIONS_REQUEST'
export const GET_MY_COLLECTIONS_SUCCESS = 'GET_MY_COLLECTIONS_SUCCESS'
export const GET_MY_COLLECTIONS_FAIL = 'GET_MY_COLLECTIONS_FAIL'
export const GET_MY_COLLECTIONS_RESET = 'GET_MY_COLLECTIONS_RESET'

// Get My Processes Constants
export const GET_MY_PROCESSES_REQUEST = 'GET_MY_PROCESSES_REQUEST'
export const GET_MY_PROCESSES_SUCCESS = 'GET_MY_PROCESSES_SUCCESS'
export const GET_MY_PROCESSES_FAIL = 'GET_MY_PROCESSES_FAIL'
export const GET_MY_PROCESSES_RESET = 'GET_MY_PROCESSES_RESET'

// Get My Statistics Constants
export const GET_MY_STATISTICS_REQUEST = 'GET_MY_STATISTICS_REQUEST'
export const GET_MY_STATISTICS_SUCCESS = 'GET_MY_STATISTICS_SUCCESS'
export const GET_MY_STATISTICS_FAIL = 'GET_MY_STATISTICS_FAIL'
export const GET_MY_STATISTICS_RESET = 'GET_MY_STATISTICS_RESET'

// Update Collection Constants
export const UPDATE_COLLECTION_REQUEST = 'UPDATE_COLLECTION_REQUEST'
export const UPDATE_COLLECTION_SUCCESS = 'UPDATE_COLLECTION_SUCCESS'
export const UPDATE_COLLECTION_FAIL = 'UPDATE_COLLECTION_FAIL'
export const UPDATE_COLLECTION_RESET = 'UPDATE_COLLECTION_RESET'

// Delete Collection Constants
export const DELETE_COLLECTION_REQUEST = 'DELETE_COLLECTION_REQUEST'
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS'
export const DELETE_COLLECTION_FAIL = 'DELETE_COLLECTION_FAIL'
export const DELETE_COLLECTION_RESET = 'DELETE_COLLECTION_RESET'

export const GET_PROCESS_DEFAULTS_REQUEST = 'GET_PROCESS_DEFAULTS_REQUEST';
export const GET_PROCESS_DEFAULTS_SUCCESS = 'GET_PROCESS_DEFAULTS_SUCCESS';
export const GET_PROCESS_DEFAULTS_FAIL = 'GET_PROCESS_DEFAULTS_FAIL';
export const GET_PROCESS_DEFAULTS_RESET = 'GET_PROCESS_DEFAULTS_RESET';

